<div class="comments-details">
  <div *ngIf="comments.value.id !== 0 || editMode" class="comments-info-container">
    <div *ngIf="comments.value.id !== 0 && !editMode" class="comments-info">
      <table>
        <tr>
          <td class="value">{{ comments.value.name }}</td>
        </tr>
        <tr>
          <td>{{ comments.value.content }}</td>
        </tr>
      </table>

      <div class="btn">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "commentsDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deleteComment()">
          <span class="material-icons-outlined">delete</span>
          {{ "commentsDetails.deleteButton" | translate }}
        </button>
      </div>
    </div>
    <form [formGroup]="commentsForm" *ngIf="editMode" class="comment-form">

      <div class="form-group">
        <p-editor #editor formControlName="description" [style]="{ width: '100%' }" [modules]="{ toolbar: false }"
          (onTextChange)="autoResize($event)"></p-editor>


        <messages class="msg" [form]="commentsForm" [messagesObserver]="messages" fieldname="description"
          [showNonFieldKeys]="TRUE" [showFieldName]="TRUE" [showFieldKeys]="FALSE"></messages>
        <action-button class="btn-save" (actionEvent)="saveComment($event)" label="➤">
        </action-button>
      </div>

    </form>
  </div>

</div>